export const userKeys = {
  all: () => ['users'],
  allDetail: () => [...userKeys.all(), 'detail'],
  detail: (id: number | string) => [...userKeys.allDetail(), Number(id)],
  segmentation: (id: number | string) => [
    ...userKeys.detail(id),
    'segmentation',
  ],
};
